import { Icon } from "@circle-react-shared/Icon";
import { SuggestionMenu } from "@circle-react-shared/SuggestionMenu";
import type { SuggestionItem } from "@circle-react-shared/SuggestionMenu/types";
import type { SuggestionListHandle } from "@circle-react-shared/SuggestionMenu/useSuggestionListKeyboard";
import { useSuggestionListKeyboard } from "@circle-react-shared/SuggestionMenu/useSuggestionListKeyboard";
import type { Editor, Range } from "@tiptap/core";
import { forwardRef } from "react";

import type { Command, CommandItem as CommandItemType } from "./types";

export interface CompassCommandsListProps {
  clientRect?: (() => DOMRect | null) | null;
  editor: Editor;
  items: CommandItemType[];
  query?: string;
  range: Range;
}

export const CompassCommandsList = forwardRef<
  SuggestionListHandle,
  CompassCommandsListProps
>(({ clientRect, editor, items, query = "", range }, ref) => {
  const groups = items.map(category => ({
    id: category.name,
    label: category.name,
    items: category.commands.map(command => ({
      id: command.name,
      label: command.title,
      visual: <Icon type={command.icon} size={16} className="text-primary" />,
      data: command,
    })),
  }));

  const { isOpen, menuRef } = useSuggestionListKeyboard({
    ref,
    query,
    isEnabled: groups.some(group => group.items.length > 0),
  });

  const onSelect = (item: SuggestionItem) => {
    (item.data as Command).command({ editor, range });
  };

  return (
    <SuggestionMenu
      ref={menuRef}
      open={isOpen}
      groups={groups}
      getAnchorRect={() => clientRect?.() ?? null}
      anchorContextElement={editor.view.dom}
      onSelect={onSelect}
    />
  );
});

CompassCommandsList.displayName = "CompassCommandsList";
